import { motion } from 'framer-motion';

interface SlideInProps {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  direction?: 'left' | 'right' | 'down' | 'up';
}

const SlideIn = ({ children, direction = 'up', duration = 0.6, delay = 0 }: SlideInProps) => {
  const variants = {
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
    hidden: {
      opacity: 0.6,
      x: direction === 'left' ? 45 : direction === 'right' ? -45 : 0,
      y: direction === 'up' ? 45 : direction === 'down' ? -45 : 0,
    },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration, delay, ease: 'easeOut' }}
      variants={{
        visible: variants.visible,
        hidden: variants.hidden,
      }}
    >
      {children}
    </motion.div>
  );
};

export default SlideIn;
